import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

// External components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Translation
import { useTranslation } from "react-i18next";

// APIs
import getPhishings from "api/phishing/getPhishings";

// MUI
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { Icon } from "@mui/material";
import { useMaterialUIController } from "context";
import Pagination from "../stealers/pagination";

// Pagination component

const Phishing = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(null);

  const [controller] = useMaterialUIController();
  const { user } = controller;

  const getData = async () => {
    try {
      const response = await getPhishings(page);

      const { results, totalPages } = response;
      setData(results);
      setPages(totalPages);
    } catch (e) {
      console.log("error --->", e);
    }
  };

  useEffect(() => {
    getData();
  }, [page]);

  const goToDetails = (id) => {
    navigate(`/phishing/${id}`);
  };

  const displayWebsiteStatus = (statusNumber) => {
    switch (statusNumber) {
      case 2:
        return <p style={{ color: "#FFB200" }}>{t("phishing.website_status_in_progress")}</p>;
      case 3:
        return <p style={{ color: "#399918" }}>{t("phishing.website_status_disabled")}</p>;
      case 4:
        return <p style={{ color: "#6c757d" }}>{t("phishing.takedown_status_false_positive")}</p>;
      case 5:
        return <p style={{ color: "#EE4E4E" }}>{t("phishing.takedown_status_failed")}</p>;
      case 6:
        return <p style={{ color: "#6c757d" }}>{t("phishing.takedown_status_not_processable")}</p>;
      default:
        return <p>/</p>;
    }
  };

  useEffect(() => {
    console.log("pages --->", pages);
  }, [page]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Title */}
      <h2 className="page-title">Phishings</h2>

      {/* Page description */}
      <p style={{ fontSize: "small" }}>{t("phishing.page_description")}</p>

      {/* Table */}
      <div className="table_users_list" style={{ maxWidth: "900px", marginTop: "20px" }}>
        <table className="table-content" cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>{t("phishing.first_seen")}</th>
              <th style={{ textAlign: "center" }}>{t("phishing.victim_name")}</th>
              <th style={{ textAlign: "center" }}>{t("phishing.victim_nation")}</th>
              <th style={{ textAlign: "center" }}>{t("phishing.domain")}</th>
              <th style={{ textAlign: "center" }}>{t("phishing.geo_location")}</th>
              <th style={{ textAlign: "center" }}>{t("phishing.details")}</th>
              <th style={{ textAlign: "center" }}>{t("phishing.website_status")}</th>
              <th style={{ textAlign: "center" }}>{t("stealers.status")}</th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0
              ? data.map((item) => (
                  <tr key={item.id}>
                    <td>{moment(item.firstSeen).format("DD/MM/YYYY")}</td>
                    <td>{item.victim?.name || "N/A"}</td>
                    <td>{item.victim?.country || "N/A"}</td>
                    <td style={{ maxWidth: "300px" }}>{item.domain || "N/A"}</td>
                    <td>
                      {item.city || "N/A"}, {item.countryCode || "N/A"}
                    </td>
                    <td>
                      <IconButton
                        onClick={() => goToDetails(item.id)}
                        className="default-button"
                        size="small"
                        disableRipple
                      >
                        {t("details")}
                      </IconButton>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {displayWebsiteStatus(item.takeDownStatus)}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {user &&
                      user.id &&
                      item.managedBy &&
                      item.managedBy.length > 0 &&
                      item.managedBy.includes(user.id) ? (
                        <Tooltip title={t("phishing.managed")} placement="top">
                          <Icon style={{ marginLeft: "5px", color: "green" }} fontSize="medium">
                            check
                          </Icon>
                        </Tooltip>
                      ) : (
                        <Tooltip title={t("phishing.not_managed_yet")} placement="top">
                          <Icon style={{ marginLeft: "5px", color: "red" }} fontSize="medium">
                            close
                          </Icon>
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>

        {/* PAGINAZIONE */}
        {pages && pages > 1 ? <Pagination setPage={setPage} pages={pages} active={page} /> : null}
      </div>
    </DashboardLayout>
  );
};

export default Phishing;
